/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { PrintingQueueGridDto } from './PrintingQueueGridDto';
import {
    PrintingQueueGridDtoFromJSON,
    PrintingQueueGridDtoFromJSONTyped,
    PrintingQueueGridDtoToJSON,
} from './PrintingQueueGridDto';

/**
 * 
 * @export
 * @interface PrintingQueueGridDtoPaginatedResults
 */
export interface PrintingQueueGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof PrintingQueueGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<PrintingQueueGridDto>}
     * @memberof PrintingQueueGridDtoPaginatedResults
     */
    results?: Array<PrintingQueueGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof PrintingQueueGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the PrintingQueueGridDtoPaginatedResults interface.
 */
export function instanceOfPrintingQueueGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrintingQueueGridDtoPaginatedResultsFromJSON(json: any): PrintingQueueGridDtoPaginatedResults {
    return PrintingQueueGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function PrintingQueueGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrintingQueueGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(PrintingQueueGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function PrintingQueueGridDtoPaginatedResultsToJSON(value?: PrintingQueueGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(PrintingQueueGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

